






















































import { Component, Vue } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { MedTransGoConstants } from '@/util/constants';
import { ObjectFactory } from '@/config/objectFactory';
import { ApiRequest } from '@/types/request';
import { ToastEvent } from '@/types/event';
import { EventBus } from '@/main';
import { CommonUtils } from '@/util/commonUtils';

@Component({
    mixins: [validationMixin],
    data() {
        return {
            chargeExcel: {
                file: FormData,
                filename: '',
            },
            requestType: '',
        };
    },
    validations: {
        chargeExcel: {
            filename: {
                required,
            },
        },
        requestType: {
            required,
        },
    },
})
export default class UploadBatchRequestModal extends Vue {
    private show = true;
    private showDeleteConfirmBox = false;

    private async setExcel($event: any) {
        const filename = $event.target.files[0].name.toLowerCase();
        if (filename.endsWith('.xlsx')) {
            this.$data.chargeExcel.file = $event.target.files[0];
            this.$data.chargeExcel.filename = $event.target.files[0].name;
        } else {
            const toastEvent: ToastEvent = {
                message: 'File types should be xlsx',
                title: 'Invalid file format.',
                varient: 'danger',
                timeout: 5000,
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            const inputName = 'file-input-1';
            const element = this.$refs[inputName] as any;
            element.reset();
        }
    }
    private async uploadBatchDeliverViaExcel() {
        const excelFormData = new FormData();
        excelFormData.append('file', this.$data.chargeExcel.file);
        excelFormData.append('requestType', this.$data.requestType);
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_REQUESTS_V2}/delivery/upload`,
            data: excelFormData,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.post<any>(apiRequest);
        if (response && response.data) {
            let successRequest = 0 ;
            let failedRequest = 0 ;
            const result = response.data.result;
            result.forEach((element: any) => {
                if (element.success) {
                    successRequest++;
                } else {
                    failedRequest++;
                    CommonUtils.showError(element);
                }
            });
            if (successRequest > 0) {
                const toastEvent: ToastEvent = {
                    message: `${successRequest} Delivery requests have been successfully submitted`,
                    title: 'Success!',
                    varient: 'success',
                    timeout: 5000,
                };
                EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
                this.$emit('success');
                this.close();
            }
            if (failedRequest > 0) {
                const toastEvent: ToastEvent = {
                    message: `${failedRequest} Delivery requests got errors.`,
                    title: 'Error',
                    varient: 'danger',
                    timeout: 5000,
                };
                EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            }
        } else {
            CommonUtils.showError(response);
        }
    }
    private close() {
        // this.$emit('close');
        this.$router.back();
    }
}
